import React from 'react';
import { Grid, TextField, Typography } from '@material-ui/core';
import { TextFormattedNumber } from 'components';


const MapItemDetails = ({item, setSelectedItem}) => {
  const {
    catalogName,
    sku,
    revenueCategory1,
    revenueCategory2,
    revenueCategory3,
    revenueCategory4,
    replenishment,
    cost,
    catalogBrand,
    manufacturer,
    loyaltyProgram
  } = item;

  const handleChangeData = (
    {target: {name, value}}
  ) => setSelectedItem({...item, [name]: value});

  return (
    <div className="border-1-light-grey border-radius-8 p-6 mt-4">
      <Grid container spacing={3} className="flex">
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Dermpro Mapping
          </Typography>
          <Typography className="ml-2">
            {catalogName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            SKU
          </Typography>
          <Typography className="ml-2">
            {sku || '-'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Cost
          </Typography>
          <Typography className="ml-2">
            <TextFormattedNumber
              value={cost || 0}
              prefix="$"
            />
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Frequency
          </Typography>
          <Typography className="ml-2">
            {replenishment ?
              <TextFormattedNumber
                value={replenishment}
                decimalScale={0}
                suffix=" per year"
              />
              : '-'
            }
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Brand
          </Typography>
          <Typography className="ml-2">
            {catalogBrand || '-'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Manufacturer
          </Typography>
          <Typography className="ml-2">
            {manufacturer || '-'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Loyalty Program
          </Typography>
          <Typography className="ml-2">
            {loyaltyProgram || '-'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} />
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Revenue Category 1
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label="Revenue Category 1"
            name="revenueCategory1"
            value={revenueCategory1}
            onChange={handleChangeData}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Revenue Category 2
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label="Revenue Category 2"
            name="revenueCategory2"
            value={revenueCategory2}
            onChange={handleChangeData}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Revenue Category 3
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label="Revenue Category 3"
            name="revenueCategory3"
            value={revenueCategory3}
            onChange={handleChangeData}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className="mb-2" variant="h6">
            Revenue Category 4
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label="Revenue Category 4"
            name="revenueCategory4"
            value={revenueCategory4}
            onChange={handleChangeData}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default MapItemDetails;
